<template>
  <div class="shared-plain-btn">
    <router-link class="shared-plain-btn__router" :to="path" itemprop="url">
      {{ copy }} <Icon v-if="icon" class="shared-plain-btn__router__icon" :icon="icon" />
    </router-link>
  </div>
</template>

<script>
import Icon from "objects/Icon";
export default {
  components: {
    Icon
  },
  props: {
    copy: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true,
      default: "/"
    },
    icon: {
      type: String,
      required: true,
      default: "/"
    }
  }
};
</script>

<style lang="scss">
.shared-plain-btn {
  &__router {
    padding: 3px;
    margin-left: -3px;

    &__icon {
      @include transition(0.3s ease all);
      max-width: 30px;
      max-height: 30px;
      margin-left: var(--grid-gutter-half);
      .shared-plain-btn__router:hover & {
        @include transform(translate(5px));
      }
      svg {
        max-width: 30px;
        max-height: 30px;
      }
    }
  }
}
</style>
